module.exports = __webpack_public_path__ + "static/img/pm2-logo.37a8f9e.png";